/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SettingsGQLService } from 'src/app/shared/services/settings/settings.graphql.service';

@Component({
  selector: 'app-two-factor-authentication-modal',
  templateUrl: './two-factor-authentication-modal.component.html',
  styleUrls: ['./two-factor-authentication-modal.component.css'],
})
export class TwoFactorAuthenticationModalComponent {
  @Output() twoFactorEnabled = new EventEmitter<boolean>();

  message = '';
  @Input() secret: string;
  @Input() modalRef: any;

  constructor(private settingsGqlService: SettingsGQLService) {}

  submitTwoFactorAuthenticationCode(code: string) {
    this.settingsGqlService
      .verifyTwoFactorAuthenticationCode(code, this.secret)
      .subscribe({
        next: ({ data }) => {
          if (data?.verifyTwoFactorAuthenticationCode === true) {
            this.settingsGqlService
              .verifyTwoFactorAuthenticationCode(code, this.secret)
              .subscribe({
                next: ({ data }) => {
                  if (data) {
                    this.message = 'Two factor authentication verified';

                    setTimeout(() => {
                      this.modalRef.close();
                      this.twoFactorEnabled.emit(true);
                    }, 3000);
                  } else {
                    this.message = 'Two factor authentication code is invalid';
                  }
                },
              });
          }
        },
        error: (_error) => {
          this.message = 'Two factor authentication code is invalid';
        },
      });
  }
}
